import React, { useEffect } from 'react'
import LoadingIndicator from '@/components/LoadingIndicator'
import { switchInstitution } from '@/utils/switchInstitution'
import { parseQueryString } from '@/utils/url'
import { getStore } from '@/store'
import { push } from 'react-router-redux'

export function InstitutionRedirection (props) {
  const qs = parseQueryString(props.location.search)

  useEffect(() => {
    if (qs && qs.institutionId && qs.url) {
      switchInstitution(null, qs.institutionId, qs.url)
    } else {
      getStore().dispatch(push('/'))
    }
  })

  return (
    <LoadingIndicator />
  )
}



// WEBPACK FOOTER //
// ./src/report-app/institutionRedirection.js